module.exports = __webpack_public_path__ + "static/media/left.872e2b92.svg";